module.exports = __webpack_public_path__ + "static/img/Haumole-Olakauatu.00896c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Haumole-Olakauatu.jpg
// module id = w4IK
// module chunks = 0